import { CwjWorkflowEngineError } from "./types.js";
export class MemoryCwjWorkflowStore {
    constructor() {
        this.workflows = new Map();
    }
    async load(workflowId) {
        return this.workflows.get(workflowId);
    }
    async save(workflow, expectedVersion) {
        const existing = this.workflows.get(workflow.workflowId);
        if (existing) {
            if (existing.version !== expectedVersion) {
                throw new CwjWorkflowEngineError(`concurrency: expected version ${expectedVersion}, found ${existing.version}`, "concurrency");
            }
        }
        else if (expectedVersion !== 0) {
            throw new CwjWorkflowEngineError(`concurrency: workflow ${workflow.workflowId} does not exist (expected version ${expectedVersion})`, "concurrency");
        }
        this.workflows.set(workflow.workflowId, workflow);
    }
    async list(filters) {
        let items = Array.from(this.workflows.values());
        if (!filters)
            return items;
        if (filters.projectId !== undefined) {
            items = items.filter((w) => w.context.projectId === filters.projectId);
        }
        if (filters.skillId !== undefined) {
            items = items.filter((w) => w.context.skillId === filters.skillId);
        }
        if (filters.tenantId !== undefined) {
            items = items.filter((w) => w.context.tenantId === filters.tenantId);
        }
        if (filters.ownerId !== undefined) {
            items = items.filter((w) => w.context.ownerId === filters.ownerId);
        }
        if (filters.status !== undefined) {
            items = items.filter((w) => w.status === filters.status);
        }
        return items;
    }
}
//# sourceMappingURL=memoryWorkflowStore.js.map